var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pivot-widget" },
    [
      _c(
        "div",
        { staticClass: "widget-header" },
        [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "i",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        placement: "top",
                        theme: "light",
                        arrow: true,
                        animation: "scale-extreme",
                        duration: [200, 200],
                        hideOnClick: true,
                      },
                      expression:
                        "{\n                    placement: 'top',\n                    theme: 'light',\n                    arrow: true,\n                    animation: 'scale-extreme',\n                    duration: [200, 200],\n                    hideOnClick: true,\n                }",
                    },
                  ],
                  staticClass: "material-icons drag-handle",
                  attrs: { content: "Sürükleyerek taşıyabilirsiniz" },
                },
                [_vm._v("\n                drag_indicator\n            ")]
              ),
              _vm._v(" "),
              _c("widget-title", {
                attrs: { widget: _vm.widget, table: _vm.table },
                on: { "widget-updated": _vm.handleWidgetUpdated },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("widget-actions", {
            attrs: {
              title: _vm.widget.title,
              widget: _vm.widget,
              table: _vm.table,
            },
            on: {
              fullscreen: _vm.handleFullscreen,
              edit: _vm.handleEdit,
              rename: _vm.handleRename,
              duplicate: _vm.handleDuplicate,
              dock: _vm.handleDock,
              export: _vm.handleExport,
              delete: function ($event) {
                return _vm.$emit("delete", _vm.widget._id)
              },
              "widget-updated": _vm.handleWidgetUpdated,
              "widget-duplicated": _vm.handleWidgetDuplicated,
              "widget-deleted": _vm.handleWidgetDeleted,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "widget-content" }, [
        !_vm.hasValidSettings
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c(
                  "a-empty",
                  {
                    attrs: {
                      description: _vm.$t("table.pivotSettingsNotConfigured"),
                    },
                  },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleEdit },
                      },
                      [_vm._v(_vm._s(_vm.$t("table.editSettings")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm.loading
          ? _c(
              "div",
              { staticClass: "loading-overlay" },
              [
                _c("loading-wave", {
                  attrs: { text: _vm.$t("table.pivotLoading") },
                }),
              ],
              1
            )
          : _vm.pivotData && _vm.pivotData.error
          ? _c(
              "div",
              { staticClass: "error-state" },
              [
                _c(
                  "a-empty",
                  {
                    attrs: {
                      description:
                        _vm.pivotData.message || _vm.$t("table.pivotLoadError"),
                    },
                  },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleEdit },
                      },
                      [_vm._v(_vm._s(_vm.$t("table.checkSettings")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : !_vm.pivotData ||
            !_vm.pivotData.rows ||
            _vm.pivotData.rows.length === 0
          ? _c(
              "div",
              { staticClass: "empty-state" },
              [
                _c("a-empty", {
                  attrs: { description: "Gösterilecek veri bulunamadı" },
                }),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "pivot-container" },
              [
                _c("pivot-table", {
                  attrs: {
                    data: _vm.pivotData,
                    config: _vm.widget.settings,
                    metadata: _vm.pivotMetadata,
                    "value-fields": _vm.widget.settings.valueFields,
                  },
                }),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _vm.showSettingsModal
        ? _c("pivot-settings-modal", {
            attrs: {
              visible: _vm.showSettingsModal,
              widget: _vm.widget,
              fields: _vm.table.fields,
              table: _vm.table,
              "upstream-filters": _vm.upstreamFilters,
            },
            on: {
              close: function ($event) {
                _vm.showSettingsModal = false
              },
              save: _vm.handleSettingsSave,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }